@if (assetMapSource$ | async; as source) {
  @switch (source) {
    @case (AssetMapSourceEnum.JMAP) {
      <jmap #jmapComponent id="jmap-component"></jmap>
    }
    @case (AssetMapSourceEnum.CARTOVISTA) {
      <cartovista #cartovistaComponent id="cartovista-component"></cartovista>
    }
    @case (AssetMapSourceEnum.NONE) {
      <leaflet #leafletComponent id="leaflet-component"
               [assets]="assets"
               [allowZooming]="true" [allowPanning]="true"></leaflet>
    }
    @case (AssetMapSourceEnum.TOO_MANY_RESULTS) {
      <div id="too-many-gis-services-results" class="fx-layout-col fx-justify-center fx-align-center fx-gap-25">
        <mat-icon id="warning-icon">warning</mat-icon>
        <h4 id="too-many-gis-services-results-message">
          {{ "LABEL.TOO_MANY_GIS_SERVICES_CONFIGURED" | translate }}
        </h4>
      </div>
    }
  }
}
